import React from 'react';
import PropTypes from 'prop-types';

import OutlinedTextField from '../textFields/OutlinedTextField';
import SubmitButton from '../buttons/SubmitButton';

import baseStyles from '../../../styles/baseStyles.module.scss';
import formStyles from '../styles/styles.module.scss';
import styles from './styles/styles.module.scss';

const CouponCode = ({ text, expanded, showHandler, applyHandler, changeHandler, removeHandler, isSuccess, isError, errorMessage, value }) => {
  let content;
  if (expanded) {
    const applyButtonContent = !isSuccess ? (
      <SubmitButton text={text.applyText} handler={applyHandler} variant="outline" />
    ) : (
      <SubmitButton text={text.removeText} handler={removeHandler} variant="outline" />
    );

    content = (
      <div className={formStyles.inputGroup}>
        <OutlinedTextField
          label={text.couponCode}
          isSuccess={isSuccess}
          isDisabled={isSuccess}
          isError={isError}
          errorMessage={errorMessage}
          value={value}
          changeHandler={changeHandler}
          enterKeyHandler={applyHandler}
        />
        {applyButtonContent}
      </div>
    );
  } else {
    content = (
      <div className={`${baseStyles.link} ${styles.link}`} onClick={showHandler}>
        {text.showCouponCodeText}
      </div>
    );
  }
  return <div className={styles.container}>{content}</div>;
};

CouponCode.defaultProps = {
  applyHandler: () => {},
  removeHandler: () => {},
  text: {
    couponCode: '',
    applyText: 'Apply',
    removeText: 'Remove',
    showCouponCodeText: 'Have a coupon code?'
  }
};

CouponCode.propTypes = {
  showHandler: PropTypes.func.isRequired,
  applyHandler: PropTypes.func,
  removeHandler: PropTypes.func,
  text: PropTypes.shape({
    couponCode: PropTypes.string,
    applyText: PropTypes.string,
    showCouponCodeText: PropTypes.string,
    removeText: PropTypes.string
  })
};

export default CouponCode;
